module.exports = "<div seedelement class=\"lui-card-vertical\">\n  <slot></slot>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-card/theme/lui-card.html
// module id = 375
// module chunks = 0 1 36